export default "__VITE_ASSET__s44k3mLJ__"